import { Form, Input } from 'antd'
import React from 'react'
import { InfoModal } from '../common'

const InputInfo = ({
  label,
  name,
  required,
  requiredMessage,
  placeholder,
  info,
}) => {
  return (
    <Form.Item label={label}>
      <Form.Item
        name={name}
        noStyle
        rules={[
          {
            required: required,
            message: requiredMessage,
          },
        ]}
      >
        <Input placeholder={placeholder} />
      </Form.Item>
      <span className="input-info">
        <InfoModal>{info}</InfoModal>
      </span>
    </Form.Item>
  )
}
export default InputInfo
